export default {
  title: 'Create Your Courses Account',
  description: `"Tell me and I forget, teach me and I may remember, involve me and I learn." - Benjamin Franklin`,
};
